<template>
    <div class="current-day">
        <b-container>
            <CurrentPhase :dayNum="store.currentDay" :dayStage="store.dayStage"/>
            <CurrentDay :dayNum="store.currentDay" :dayStage="store.dayStage" @next="next" @end="end" @ranking="ranking" @previous="previous" />
        </b-container>
    </div>
</template>

<script>
    import CurrentPhase from '@/components/CurrentPhase'
    import CurrentDay from '@/components/CurrentDay'

    export default {
        name: "Day",
        data() {
            return {
                price: 0,
            }
        },
        beforeRouteEnter (to, from, next) {
            next( vm => {
                if(to.params.day !== vm.$root.$data.store.currentDay) {
                    vm.$router.push({name: 'day', params: {day: vm.$root.$data.store.currentDay}})
                }
            });
        },
        beforeRouteUpdate (to, from, next) {
            next();
        },
        computed:{
            store() {
                return this.$root.$data.store;
            }
        },
        methods: {
            next() {
                if (this.store.dayStage === 'Supplier') {
                    this.store.dayStage = 'Customer';
                }
                else if (this.$root.hasNext) {
                    if (this.store.dayStage === 'Customer') {
                        this.store.dayStage = 'Supplier';
                    }
                    this.store.currentDay = this.store.currentDay + 1;
                    this.$router.push({name: 'day', params: {day: this.store.currentDay}})
                }
            },
            previous() {
                if (this.store.dayStage !== 'Customer' && this.store.dayStage !== 'Supplier') {
                    this.store.dayStage = 'Customer';
                }
                else if (this.store.dayStage === 'Customer') {
                    this.store.dayStage = 'Supplier';
                } else if (this.store.currentDay > 1) {
                    this.store.dayStage = 'Customer';
                    this.store.currentDay = this.store.currentDay - 1;
                    this.$router.push({name: 'day', params: {day: this.store.currentDay}})
                }
            },
            end() {
                this.store.dayStage = 'GameEnd';
            },
            ranking() {
                this.store.dayStage = 'Ranking';
                this.$router.push({name: 'dashboard', params: {type: 'ranking'}})
            }
        },
        components: {CurrentDay, CurrentPhase}
    }
</script>

<style scoped>

</style>
